import '../css/index.scss';
import $ from 'jquery';
import luxy, { windowHeight } from 'luxy.js';

/**js**/
'use strict';

const winWidth = window.innerWidth;
const winHeight = window.innerHeight;
var BREAKPOINT_SP = 768;

window.addEventListener('load',function(){

  let vw = winWidth * 0.01;
  // document.documentElement.style.setProperty('--vw', `${vw}px`);
  let vh = winHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // const body = document.querySelector('body');
  // setTimeout(() => {
  //   body.classList.add('opening');
  //   setTimeout(() => {
  //     body.classList.add('complete');
  //     body.classList.remove('opening');
  //   },2400);
  // },1000);

  // UA
  const _ua = (function(u){
    return {
      Tablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
        || u.indexOf("ipad") != -1
        || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
        || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
        || u.indexOf("kindle") != -1
        || u.indexOf("silk") != -1
        || u.indexOf("playbook") != -1,
      Mobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
        || u.indexOf("iphone") != -1
        || u.indexOf("ipod") != -1
        || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
        || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
        || u.indexOf("blackberry") != -1
    }
  })(window.navigator.userAgent.toLowerCase());

  if(!_ua.Mobile && !_ua.Tablet){

    // Luxy 初期化
    luxy.init({
      wrapper: '#luxy-wrap',
      targets: '.luxy-el',
      wrapperSpeed: 0.2
    });

  } else {

    const HeroArea = document.querySelector(".c-top");
    const HeroAreaInner = document.querySelector(".c-top .box__content");
    console.log(HeroArea);
    HeroArea.style.maxHeight = ((vh * 100) + (vw * 10)) +'px';
    HeroAreaInner.style.maxHeight = ((vh * 100) + (vw * 10)) +'px';

  }

});

/*----------------------------------------------------------
load
----------------------------------------------------------*/

window.addEventListener("load", function () {

  setTimeout(() => {
    document.querySelector("body").classList.add("complete");
  }, 600);

});

/*----------------------------------------------------------
resize
----------------------------------------------------------*/

var resizeTimer;
var interval = 300;

window.addEventListener('resize',function() {

  if (resizeTimer !== false) {
    clearTimeout(resizeTimer);
  }

  resizeTimer = setTimeout(function() {

    const winWidth = window.innerWidth;
    const winHeight = window.innerHeight;

    // let vw = winWidth * 0.01;
    // document.documentElement.style.setProperty('--vw', `${vw}px`);
    let vh = winHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

  }, interval);

});


/*----------------------------------------------------------
  Scroll
----------------------------------------------------------*/

// スクロール判定の処理を関数にまとめる
function checkScroll() {
    const targetElement = document.querySelector('body');
    const scrollThreshold = window.innerHeight * 0.8; // ブラウザ高さの80%

    const scrollPosition = window.scrollY;

    if (scrollPosition > scrollThreshold) {
        targetElement.classList.add('scrolled');
    } else {
        targetElement.classList.remove('scrolled');
    }
}

// ページ読み込み時にも判定
window.addEventListener('load', checkScroll);

// スクロール時にも判定
window.addEventListener('scroll', checkScroll);


/*----------------------------------------------------------
  animate
----------------------------------------------------------*/

function scrollAddClass() {
  const scrollEffect = document.querySelectorAll('.js-scroll');
  let windowHeight = window.innerHeight;
  for (let i = 0; i < scrollEffect.length; i++) {
    target = scrollEffect[i].getBoundingClientRect().top;
    if (target < windowHeight) {
      scrollEffect[i].classList.add('is-active');
    }
  }
}

document.addEventListener('DOMContentLoaded', scrollAddClass);
document.addEventListener('scroll', scrollAddClass);


$(function(){

  /*----------------------------------------------------------
    animate
  ----------------------------------------------------------*/

  var current_scrollY;
  current_scrollY = $( window ).scrollTop();
  triggerAnimation(current_scrollY);

  $(window).on('scroll', function () {
    current_scrollY = $( window ).scrollTop();
    triggerAnimation(current_scrollY);
  });

  function triggerAnimation(scroll) {
    const scrollBottom = scroll + $(window).height();
    $('.animate').each(function() {
      const top = $(this).offset().top;
      if(scrollBottom > top) {
        $(this).addClass('is_animated');
      } else {
        // $(this).removeClass('is_animated');
      }
    })
  }


  /*----------------------------------------------------------
    drawer-nav
  ----------------------------------------------------------*/

  const gNavi = $('.js-drawer-nav');
  const gNaviButton = $('.js-drawer-button');
  const gNaviAnchor = $('.drawer-nav .nav-item-link');
  const logoHeader = $('.js-header-logo');

  gNaviButton.on('click', function(){
    gNaviButton.toggleClass('-active');
    gNavi.toggleClass('-active');
    logoHeader.toggleClass('-active');
  });

  gNaviAnchor.on('click', function(){
    gNaviButton.toggleClass('-active');
    gNavi.toggleClass('-active');
    logoHeader.toggleClass('-active');
  });

});


/*----------------------------------------------------------
  ユーティリティ関数
----------------------------------------------------------*/

// ドキュメント基準での要素 top を取得
function getDocumentOffsetTop(el) {
  let top = 0;
  while (el) {
    top += el.offsetTop || 0;
    el = el.offsetParent;
  }
  return top;
}

// デバウンス関数
function debounce(fn, wait) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), wait);
  };
}

/*----------------------------------------------------------
  アンカー初期化
----------------------------------------------------------*/

// アンカーと対応セクションのマッピング
const targets = [
  { anchorId: 'home', sectionId: null },
  { anchorId: 'theme', sectionId: 'section-theme' },
  { anchorId: 'exhibitor', sectionId: 'section-exhibitor' },
  { anchorId: 'contents', sectionId: 'section-contents' },
  { anchorId: 'supported', sectionId: 'section-supported' },
  { anchorId: 'entrance', sectionId: 'section-entrance' }
];

// 各アンカーの絶対位置を設定
function updateAnchorPositions() {
  targets.forEach(({ anchorId, sectionId }) => {
    const anchorEl = document.getElementById(anchorId);
    if (!anchorEl) return;

    anchorEl.style.position = 'absolute';
    anchorEl.style.left = '0';
    anchorEl.style.width = '1px';
    anchorEl.style.height = '1px';
    anchorEl.style.top = sectionId
      ? `${getDocumentOffsetTop(document.getElementById(sectionId))}px`
      : '0';
  });
}

// body.complete を監視して初期化
const observer = new MutationObserver(() => {
  if (!document.body.classList.contains('complete')) return;

  updateAnchorPositions();
  observer.disconnect();

  const debouncedUpdate = debounce(updateAnchorPositions, 150);
  window.addEventListener('resize', debouncedUpdate);
  window.addEventListener('orientationchange', () => setTimeout(updateAnchorPositions, 0));
  window.addEventListener('pageshow', () => setTimeout(updateAnchorPositions, 0));

  // body 高さ変化を監視して再計算
  let lastBodyHeight = document.body.clientHeight;
  if (typeof ResizeObserver !== 'undefined') {
    const bodyResizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const newHeight = entry.contentRect.height;
        if (newHeight !== lastBodyHeight) {
          lastBodyHeight = newHeight;
          debouncedUpdate();
        }
      }
    });
    bodyResizeObserver.observe(document.body);
  }
});

observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

/*----------------------------------------------------------
  ナビ更新・スクロール制御
----------------------------------------------------------*/

const naviItems = Array.from(document.querySelectorAll('.nav-item'));
const boxes = Array.from(document.querySelectorAll('.js-anchor-target'));
let scrollTimer = null;
let isScrolling = false;

// ナビ更新関数
function updateNav() {
  if (isScrolling) return;

  const scrollTop = window.scrollY || window.pageYOffset;
  const winH = window.innerHeight;

  // ページ最上部なら Home を強制
  if (scrollTop === 0) {
    naviItems.forEach((el, i) => el.classList.toggle('here', i === 0));
    return;
  }

  let found = false;

  for (let i = 0; i < boxes.length; i++) {
    const section = boxes[i];
    const sectionId = section.id;
    const target = targets.find(t => t.sectionId === sectionId);
    if (!target) continue; // アンカーが無い section-intro などは無視

    const anchorEl = document.getElementById(target.anchorId);
    if (!anchorEl) continue;

    const top = parseInt(anchorEl.style.top, 10);

    // 次のアンカーポイントの top を取得
    const nextTarget = boxes[i + 1]
      ? document.getElementById(targets.find(t => t.sectionId === boxes[i + 1].id)?.anchorId)
      : null;
    const nextTop = nextTarget ? parseInt(nextTarget.style.top, 10) : Infinity;

    // 現在のスクロール位置がこのセクション内にあるか
    if (scrollTop >= top && scrollTop < nextTop) {
      naviItems.forEach((el, idx) => el.classList.toggle('here', idx === i));
      found = true;

      // CTA 制御（ウィンドウ高さの 25% 手前で反映）
      const cta = document.getElementById('cta');
      if (cta) {
        const triggerPoint = top - winH * 0.25;
        cta.classList.toggle('disable', scrollTop >= triggerPoint && (sectionId === 'section-supported' || sectionId === 'section-entrance'));
      }

      break;
    }
  }

  // どのアンカー範囲にも入っていない場合
  if (!found) {
    const themeAnchor = document.getElementById('theme');
    const themeTop = themeAnchor ? parseInt(themeAnchor.style.top, 10) : 0;

    if (scrollTop < themeTop) {
      // section-theme より前なら home
      naviItems.forEach((el, i) => el.classList.toggle('here', i === 0));
    } else {
      // それ以外なら最後のナビ
      naviItems.forEach((el, i) => el.classList.toggle('here', i === naviItems.length - 1));
    }
  }
}

// スクロールイベント（50ms 間引き）
window.addEventListener('scroll', () => {
  clearTimeout(scrollTimer);
  scrollTimer = setTimeout(updateNav, 50);
});

// ページロード時に画像ロードを待って初回判定
window.addEventListener('load', () => {
  updateNav();
  const images = Array.from(document.images);
  let loadedCount = 0;

  if (images.length === 0) return;

  images.forEach(img => {
    if (img.complete) loadedCount++;
    else img.addEventListener('load', () => {
      loadedCount++;
      if (loadedCount === images.length) updateNav();
    });
  });

  setTimeout(updateNav, 200);
});

/*----------------------------------------------------------
  スムーススクロール
----------------------------------------------------------*/

document.querySelectorAll('.nav-item-link').forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();

    if( winWidth > BREAKPOINT_SP ){

      const anchorId = link.getAttribute('data-anchor');
      const anchorEl = document.getElementById(anchorId);
      if (!anchorEl) return;

      const top = parseInt(anchorEl.style.top, 10);
      if (!Number.isFinite(top)) return;

      isScrolling = true;
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });

      // スクロール完了後に here 更新
      setTimeout(() => {
        naviItems.forEach(el => el.classList.remove('here'));
        link.parentElement.classList.add('here');
        isScrolling = false;
      }, 600);

    } else {

      //クリックしたリンクのhref属性を取得
      const href = link.getAttribute('href');
      //目的のセクションを取得
      const targetSection = document.querySelector(href);
      //画面の上からセクションのtop位置までの垂直方向の距離
      const sectionTop = targetSection.getBoundingClientRect().top;
      //現在位置を取得
      const currentPos = window.scrollY;
      //ヘッダーの高さ
      const gap = 100;
      //現在位置から目的のsectionまでのスクロール量
      const target = sectionTop + currentPos;
      //特定の位置までスクロールさせる
      window.scrollTo({
        top: target, //目的の位置のY座標を指定
        behavior: 'smooth', //スクロールの動きを指定
      });

    }

  });
});



/*----------------------------------------------------------
video
----------------------------------------------------------*/

document.addEventListener("DOMContentLoaded", function () {

  const videos = document.querySelectorAll(".video");
  let currentSize = '';

  function updateVideoSource(video, baseSrc) {

    const suffix = window.innerWidth <= 768 ? "_sp" : "_pc";
    const sourceMP4 = document.createElement("source");

    sourceMP4.setAttribute("src", baseSrc + suffix + ".mp4");
    sourceMP4.setAttribute("type", "video/mp4");

    video.innerHTML = "";
    video.appendChild(sourceMP4);
  }

  videos.forEach((video) => {
    const baseSrc = video.getAttribute("data-src");
    updateVideoSource(video, baseSrc);
  });

  // window.addEventListener("resize", function () {
  //   const newSize = window.innerWidth;
  //   if (currentSize !== newSize) {
  //     currentSize = newSize;
  //     videos.forEach((video) => {
  //       const baseSrc = video.getAttribute("data-src");
  //       updateVideoSource(video, baseSrc);
  //     });
  //   }
  // });

});


/*----------------------------------------------------------
panzoom
----------------------------------------------------------*/

const panzoomEl = document.getElementById('panzoom');
const instance = panzoom(panzoomEl, {
	smoothScroll: true,
	transformOrigin: {x: 0.5, y: 0.5}, // change center point of wheel zoom.
	initialZoom: 1,
	bounds: true,
	boundsPadding: 0.8,
	maxZoom: 5,
	minZoom: 1,
	zoomDoubleClickSpeed: 1.0,  // disable doubleclick zoom
	//beforeWheel: function(e) {return true;} // disable wheel zoom
});

// cancel a-tag event when pan.
let isPan = false;
instance.on('pan', function (e) {
	isPan = true;
});

instance.on('panend', function (e) {
	setTimeout(function () {
		isPan = false;
	}, 1);
});

// panzoomEl.addEventListener('click', function (e) {
// 	if (isPan && e.srcElement.nodeName === 'A') e.preventDefault();
// });

// zoom events
const zoomInEl = document.getElementById('zoomIn');
const zoomOutEl = document.getElementById('zoomOut');
const zoomResetEl = document.getElementById('zoomReset');

const isScale = instance.getTransform().scale;
zoomInEl.disabled = isScale >= 5;
zoomOutEl.disabled = isScale <= 1;

const zoomInOut = (isIn) => {
	const tf = instance.getTransform();
	const scale = 1 + 0.25 * (isIn ? 1 : -1);
	instance.zoomTo(panzoomEl.clientWidth / 2, panzoomEl.clientHeight / 2, scale);

	const isScale = instance.getTransform().scale;
	zoomInEl.disabled = isScale >= 5;
	zoomOutEl.disabled = isScale <= 1;
};

const zoomReset = () => {
	instance.moveTo(0, 0);
	instance.zoomTo(0, 0, 0);
	const isScale = instance.getTransform().scale;
	zoomInEl.disabled = isScale >= 5;
	zoomOutEl.disabled = isScale <= 1;
};

zoomInEl.addEventListener('click', (e) => {
	e.preventDefault();
	zoomInOut(true);
});
zoomInEl.addEventListener('touchend', () => {
	zoomInOut(true);
});

zoomOutEl.addEventListener('click', (e) => {
	e.preventDefault();
	zoomInOut(false);
});
zoomOutEl.addEventListener('touchend', () => {
	zoomInOut(false);
});

zoomResetEl.addEventListener('click', (e) => {
	e.preventDefault();
	zoomReset();
});
zoomResetEl.addEventListener('touchend', () => {
	zoomReset();
});

// zoom adjustment after img loaded.
const imgEl = panzoomEl.getElementsByTagName('img')[0];
const imageMap = new Image();
imageMap.onload = function () {
	const dw = panzoomEl.clientWidth / this.naturalWidth;
	const dh = panzoomEl.clientHeight / this.naturalHeight;
	const scale = Math.min(dw, dh);
	instance.zoomAbs(
		panzoomEl.clientWidth / 2,
		panzoomEl.clientHeight / 2,
		scale
	);
	//instance.zoomAbs(dw > dh ? (panzoomEl.clientWidth) / 2 : 0, dw < dh ? panzoomEl.clientHeight / 2 : 0, scale);
};
imageMap.src = imgEl.src;


/*----------------------------------------------------------
snap
----------------------------------------------------------*/

const TOUCH_BREAKPOINT = 768; // px未満をタッチデバイス（スマホ）扱い

const sections = [
  {
    gridId: 'thumb-01',
    mainId: 'main-01',
    images: [
      { thumb: '/c/reuse-market2026/assets/img/snap/a1_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/a1_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/a2_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/a2_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/a3_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/a3_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/a4_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/a4_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/a5_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/a5_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/a6_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/a6_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/a7_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/a7_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/a8_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/a8_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/a9_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/a9_full.jpg' },
    ]
  },
  {
    gridId: 'thumb-02',
    mainId: 'main-02',
    images: [
      { thumb: '/c/reuse-market2026/assets/img/snap/b1_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/b1_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/b2_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/b2_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/b3_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/b3_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/b4_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/b4_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/b5_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/b5_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/b6_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/b6_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/b7_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/b7_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/b8_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/b8_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/b9_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/b9_full.jpg' },
    ]
  },
  {
    gridId: 'thumb-03',
    mainId: 'main-03',
    images: [
      { thumb: '/c/reuse-market2026/assets/img/snap/c1_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/c1_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/c2_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/c2_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/c3_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/c3_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/c4_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/c4_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/c5_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/c5_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/c6_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/c6_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/c7_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/c7_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/c8_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/c8_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/c9_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/c9_full.jpg' },
    ]
  },
  {
    gridId: 'thumb-04',
    mainId: 'main-04',
    images: [
      { thumb: '/c/reuse-market2026/assets/img/snap/d1_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/d1_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/d2_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/d2_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/d3_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/d3_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/d4_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/d4_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/d5_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/d5_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/d6_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/d6_full.jpg' },
      { thumb: '/c/reuse-market2026/assets/img/snap/d7_thumb.webp', full: '/c/reuse-market2026/assets/img/snap/d7_full.jpg' },
    ]
  },
];
// ==============================

function isTouchMode() {
  return window.innerWidth < TOUCH_BREAKPOINT;
}

const allSections = sections.map(({ gridId, mainId, images }) => {
  const mainEl = document.getElementById(mainId);
  const gridEl = document.getElementById(gridId);
  const imgs = [];
  let thumbs = [];
  let currentIdx = 0;
  let transitioning = false;

  images.forEach(({ thumb, full }, i) => {
    const img = document.createElement('img');
    img.src = full;
    img.alt = `photo ${i + 1}`;
    mainEl.appendChild(img);
    imgs.push(img);

    const thumbEl = document.createElement('div');
    thumbEl.className = 'thumb';
    thumbEl.innerHTML = `<img src="${thumb}" alt="thumbnail ${i + 1}" loading="lazy">`;
    gridEl.appendChild(thumbEl);
    thumbs.push(thumbEl);
  });

  // 初期表示：1枚目をtransitionなしで即表示
  imgs[0].style.opacity = '1';
  imgs[0].style.zIndex = '1';
  thumbs[0].classList.add('active');

  function switchTo(idx) {
    if (idx === currentIdx) return;
    if (isTouchMode() && transitioning) return;
    transitioning = true;

    const prevImg = imgs[currentIdx];
    const nextImg = imgs[idx];

    nextImg.classList.add('visible');
    prevImg.style.opacity = '';
    prevImg.style.zIndex = '';
    prevImg.classList.remove('visible');
    prevImg.classList.add('leaving');

    setTimeout(() => {
      prevImg.classList.remove('leaving');
      transitioning = false;
    }, 500);

    thumbs[currentIdx].classList.remove('active');
    thumbs[idx].classList.add('active');
    currentIdx = idx;
  }

  function bindEvents() {
    thumbs.forEach((thumbEl, i) => {
      // cloneNodeで既存リスナーをリセット
      const clone = thumbEl.cloneNode(true);
      thumbEl.parentNode.replaceChild(clone, thumbEl);
      thumbs[i] = clone;

      if (isTouchMode()) {
        clone.addEventListener('click', () => switchTo(i));
      } else {
        clone.addEventListener('mouseenter', () => switchTo(i));
      }
    });
  }

  bindEvents();
  return { bindEvents };
});

// リサイズ時にイベントを切り替え（debounce 200ms）
let resizeTimerSnap;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimerSnap);
  resizeTimerSnap = setTimeout(() => {
    allSections.forEach(s => s.bindEvents());
  }, 200);
});
